module.exports = __webpack_public_path__ + "img/dog-smile.084d8f0a.svg";